// La direction prépare de une à cinquante œuvres sélectionnées dans la liste.
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@artosera/ui';
import { Link } from 'react-router';
import { useGesteCatalogage } from '../../api/catalogage.js';
import { galerieEcritModule } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { useRaisonIaCatalogage } from './CatalogageBloc.js';

export function BoutonSerieCatalogage({ oeuvreIds }: { oeuvreIds: string[] }) {
  const { galerie } = useShellContext();
  if (!galerieEcritModule(galerie, 'catalogage-image') || galerie.role !== 'direction') return null;
  return <Geste oeuvreIds={oeuvreIds} />;
}

function Geste({ oeuvreIds }: { oeuvreIds: string[] }) {
  const { t } = useTranslation('regie');
  const { galerieSlug } = useShellContext();
  const raison = useRaisonIaCatalogage('catalogage:recto');
  const geste = useGesteCatalogage(galerieSlug);
  const [retour, setRetour] = useState('');
  return (
    <>
      <Button
        variant="secondary"
        title={raison ?? undefined}
        disabled={!!raison || oeuvreIds.length < 1 || oeuvreIds.length > 50 || geste.isPending}
        onClick={() =>
          geste.mutate(
            { chemin: 'series', corps: { oeuvreIds } },
            {
              onSuccess: () => setRetour(t('catalogage.serieLancee')),
              onError: () => setRetour(t('catalogage.conflit')),
            },
          )
        }
      >
        {t('catalogage.preparer.serie')}
      </Button>
      {raison && <span>{raison}</span>}
      {retour && <span role="status">{retour}</span>}
      <Link to={`/${galerieSlug}/oeuvres/catalogage`}>{t('catalogage.titre')}</Link>
    </>
  );
}
